import React from 'react';
import LoginCarousel from 'page/login/component/carousel';
import DoctorRegisterForm from './component/form';

const logo = require('asset/image/logo.png');

export default function DoctorRegisterPage() {
  return (
    <div className="flex h-screen overflow-hidden">
      <div className="hidden md:flex w-1/2 items-center justify-center bg-primary bg-onboard_bg_img bg-cover bg-center">
        <LoginCarousel />
      </div>
      <div className="flex w-full md:w-1/2 h-full min-h-0 items-stretch justify-center px-4 sm:px-6 py-4 sm:py-6">
        <div className="w-full max-w-[420px] h-full min-h-0 flex flex-col">
          <img
            alt="Logo"
            src={logo}
            className="mb-3 h-14 sm:h-16 w-full object-contain flex-shrink-0"
          />
          <div className="flex-1 min-h-0">
            <DoctorRegisterForm />
          </div>
        </div>
      </div>
    </div>
  );
}
